import { useMemo } from 'react';
import { dictionary, Locale, Dictionary } from '../lib/dictionary';

export interface I18nContext {
  locale: Locale;
  t: Dictionary;
  isSpanish: boolean;
  isEnglish: boolean;
  setLocale: (locale: Locale) => void;
}

export const useI18n = (locale: Locale, setLocale: (locale: Locale) => void): I18nContext => {
  const context = useMemo(() => ({
    locale,
    t: dictionary[locale],
    isSpanish: locale === 'es',
    isEnglish: locale === 'en',
    setLocale
  }), [locale, setLocale]);

  return context;
};

// Helper function to get nested translation values
export const getTranslation = (obj: any, path: string): string => {
  return path.split('.').reduce((current, key) => current?.[key], obj) || path;
};

// Hook for getting specific translation values
export const useTranslation = (locale: Locale) => {
  return useMemo(() => ({
    t: (key: string) => getTranslation(dictionary[locale], key),
    locale
  }), [locale]);
};
